module.exports = __webpack_public_path__ + "static/media/down-chevron.5ab5e486.svg";